export default __webpack_public_path__ + "static/img/3p_claim.3fdc875.svg";